<!-- 轮播组件 -->
<template>
  <div class="banner">
    <div class="carousel-panel">
        <img :src="bannerObj.url">
        <div class="carousel-item">
            
            <template v-if='title()' >
              <div class="carousel-item-title" style="margin-top:80px">{{ bannerObj.title }}</div>
              <div class="small">— — {{ $route.query.name }}</div>
              <div class="carousel-item-describe">{{ spBanData.obj[$route.query.name] }}</div>
            </template>
            <template v-else>
              <div class="carousel-item-title">{{ bannerObj.title }}</div>
              <div class="carousel-item-describe" v-for="item in bannerObj.describe">{{ item }}</div>
            </template>
          </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Ground',
    props: ['id'],
    data() {
      return {
        spBanData: window.spBanData
      }
    },
    computed: {
        bannerObj: function(){
            let data = window.bannerData
            return data[this.id]
        }
    },
    methods: {
      title(){
        if(this.$route.query.name&&this.spBanData.arr.includes(this.$route.query.name)){
          return true
        }
        return false
      }
    }
  }
</script>
<style scoped>
.carousel-panel{
    position: relative;
    overflow: hidden;
}
.carousel-panel img{
    margin-left: 50%;
    transform: translateX(-50%);
}
.carousel-item {
    width: 50%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-600px);
    color: #fff;
}
.carousel-item-title{
    margin: 120px 0 30px;
    font-size: 48px;
    font-weight: bolder;
}
.carousel-item-describe{
    font-size: 16px;
    line-height: 32px;
}
.small{
  padding-bottom: 30px;
  text-indent: 8em;
  font-size: 24px;
}
</style>